import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "../config";

export default function ThankYou() {
  return (
    <div data-testid="thank-you-page">
      <section className="bg-[#FAFAFA] border-b border-black/5">
        <div className="max-w-2xl mx-auto px-6 py-24 md:py-32 text-center">
          <CheckCircle2 className="w-16 h-16 text-[#4CAF50] mx-auto fade-up" />
          <p className="mt-8 text-xs tracking-[0.2em] uppercase font-bold text-[#C87A38] fade-up" style={{ animationDelay: "60ms" }}>Enquiry received</p>
          <h1 className="mt-3 text-4xl sm:text-5xl tracking-tight font-bold fade-up" style={{ animationDelay: "120ms" }}>Thank you</h1>
          <p className="mt-5 text-base md:text-lg text-[#525252] leading-relaxed fade-up" style={{ animationDelay: "180ms" }} data-testid="thank-you-message">
            Thank you for contacting Zum Flooring. We have received your flooring enquiry and will be in touch shortly.
          </p>
          <p className="mt-3 text-sm text-[#525252] fade-up" style={{ animationDelay: "240ms" }}>
            Need us sooner? Give us a call on{" "}
            <a href={BUSINESS.phoneTel} className="font-semibold text-[#4A3018] hover:text-[#C87A38] transition-colors inline-flex items-center gap-1" data-testid="thank-you-call-link">
              <Phone className="w-3.5 h-3.5" /> {BUSINESS.phoneDisplay}
            </a>
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3 fade-up" style={{ animationDelay: "300ms" }}>
            <Link to="/colours" className="inline-flex items-center gap-2 rounded-full bg-[#C87A38] px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#A6632B]" data-testid="thank-you-colours-link">
              Browse flooring colours <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/" className="inline-flex items-center rounded-full border border-[#4A3018]/20 px-6 py-3.5 text-sm font-semibold text-[#4A3018] transition-colors hover:bg-[#4A3018] hover:text-white" data-testid="thank-you-home-link">
              Back to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
